import {
  ColumnLayout,
  FormField,
  Input,
} from '@cloudscape-design/components';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import * as Yup from 'yup';

const validationSchema = Yup.object({
  length: Yup.number()
    .moreThan(0, 'Length must be greater than 0')
    .required('Length is required'),
  width: Yup.number()
    .moreThan(0, 'Width must be greater than 0')
    .required('Width is required'),
  height: Yup.number()
    .moreThan(0, 'Height must be greater than 0')
    .required('Height is required'),
  weight: Yup.number()
    .moreThan(0, 'Weight must be greater than 0')
    .required('Weight is required'),
});

export default function ParcelInputs({
  onChange,
  defaultValues = {
    length: 6,
    width: 8,
    height: 6,
    weight: 16,
  },
}) {
  const {
    values, errors, setFieldValue, isValid,
  } = useFormik({
    initialValues: defaultValues,
    validationSchema,
  });

  useEffect(() => {
    onChange?.(values, isValid);
  }, [values, isValid, onChange]);

  return (
    <ColumnLayout columns={2}>
      <FormField label="Length (inches)" errorText={errors.length}>
        <Input
          inputMode="numeric"
          value={values.length}
          onChange={({ detail }) => { setFieldValue('length', parseInt(detail.value || 0, 10)); }}
        />
      </FormField>
      <FormField label="Width (inches)" errorText={errors.width}>
        <Input
          inputMode="numeric"
          value={values.width}
          onChange={({ detail }) => { setFieldValue('width', parseInt(detail.value || 0, 10)); }}
        />
      </FormField>
      <FormField label="Height (inches)" errorText={errors.height}>
        <Input
          inputMode="numeric"
          value={values.height}
          onChange={({ detail }) => { setFieldValue('height', parseInt(detail.value || 0, 10)); }}
        />
      </FormField>
      <FormField label="Weight (oz)" errorText={errors.weight}>
        <Input
          inputMode="numeric"
          value={values.weight}
          onChange={({ detail }) => { setFieldValue('weight', parseInt(detail.value || 0, 10)); }}
        />
      </FormField>
    </ColumnLayout>
  );
}

ParcelInputs.propTypes = {
  onChange: PropTypes.func.isRequired,
  defaultValues: PropTypes.shape({
    length: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
    weight: PropTypes.number,
  }),
};
